<ion-modal (willDismiss)="onClose()" [isOpen]="isModalOpen" [initialBreakpoint]="0.60" [breakpoints]="[0, 0.60, 0.95]">
  <ng-template>
    <ion-content>
      <h2 size="large" class="text-2xl ml-4 mr-4 mt-5 mb-3 font-bold">{{ title }}</h2>
      <ng-content></ng-content>
    </ion-content>
  </ng-template>
</ion-modal>